<template>
  <v-app-bar
    app

    color="rgba(250,134,14, 0.7)"
  >
    <!--<v-app-bar-nav-icon
      class="hidden-md-and-up"
      @click="toggleDrawer"
    />-->

    <v-container class="mx-auto py-0">
      <v-row align="center">
        <v-img
          :src="require('@/assets/logo4.png')"
          class="mr-5"
          contain
          height="48"
          width="48"
          max-width="48"
          @click="$vuetify.goTo(0)"
        />

        <v-btn
          v-for="(link, i) in links"
          :key="i"
          v-bind="link"
          light
          class="hidden-sm-and-down"
          text
          @click="onClick($event, link)"
        >
          {{ link.text }}
        </v-btn>

        <v-spacer />
        <Login @close-login="loginDialog = false" :dialog="loginDialog"/>
        <Register @close-register="registerDialog = false" :dialog="registerDialog"/>
        <v-btn
            text
            @click="loginDialog = true"
        >
          Giriş
        </v-btn>
        <v-btn
            text
            @click="registerDialog = true"
        >
          Kayıt Ol
        </v-btn>

      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
  // Utilities
  import {
    mapMutations,
  } from 'vuex'

  export default {
    name: 'CoreAppBar',
    data : () => ({
      loginDialog: false,
      registerDialog: false,
      links: [
        //{text: "Home", href: "#"}
      ]
    }),
    components: {
      Login: () => import('@/components/home/Login'),
      Register: () => import('@/components/home/RegisterStudent'),
    },

    methods: {
      ...mapMutations(['toggleDrawer']),
      onClick (e, item) {
        e.stopPropagation()

        if (item.to || !item.href) return

        this.$vuetify.goTo(item.href.endsWith('!') ? 0 : item.href)
      },
    },
  }
</script>
